import type * as THREE from 'three';
import type { FilletFeaturePrototype } from '../../../feature/prototype/fillet/FilletFeaturePrototype';
import { FeatureResultObject } from '../FeatureResultObject';

/**
 * 圆角结果体对象。
 */
export class FilletResultObject extends FeatureResultObject<FilletFeaturePrototype> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: FilletFeaturePrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
